export default __webpack_public_path__ + "static/media/ABUD.b15cd632.png";